<script lang="ts">
	import { TabItem } from "flowbite-svelte-v1";
	import type { ComponentProps } from "svelte";

	type Props = ComponentProps<typeof TabItem>;

	// Thin passthrough. All tab styling is scoped on the Tabs wrapper, which is an
	// ancestor of the button/svg this renders. restProps carries open, onclick, title,
	// disabled, titleSlot and telemetry attributes (data-action-name/-title).
	let { children, ...rest }: Props = $props();
</script>

<TabItem {...rest}>
	{@render children?.()}
</TabItem>
